<script lang="ts">
  import type { CategoryPropConfig } from '../../modules/projects/project.interface';
  import { CategoryPropType } from '../../modules/projects/project.interface';
  import ItemPropTextInput from './ItemPropTextInput.svelte';
  import ItemPropCategory from './ItemPropCategory.svelte';

  export let value: any;
  export let values: any;
  export let categoryPropConfig: CategoryPropConfig;
  export let message: string;
  export let path = '';

  const Component = getComponentByType(categoryPropConfig);

  function getComponentByType(categoryPropConfig: CategoryPropConfig) {
    const components = {
      [CategoryPropType.TEXT]: ItemPropTextInput,
      [CategoryPropType.ARTICLE_CATEGORY]: ItemPropCategory,
    };

    const items = components[categoryPropConfig.type];

    return items;
  }
</script>

<div>
  <div class="prop-input">
    <svelte:component
      this={Component}
      bind:value
      bind:values
      {categoryPropConfig}
      {path}
      on:fileAdded
    />
    {#if message && message !== 'valid'}
      <span class="prop-message red-text">{message}</span>
    {/if}
  </div>
</div>

<style lang="scss">
  .prop-input {
    position: relative;
    padding-bottom: 24px;
  }

  .prop-message {
    position: absolute;
    bottom: 10px;
    font-size: 12px;
  }
</style>
